import { css } from '@/styled-system/css';
import { cva } from '@/styled-system/css';

export const tooltipTriggerStyles = css({
  display: 'inline-block',
  cursor: 'pointer',

  '&:focus': {
    outlineOffset: '-1px',
  },
});

export const tooltipPortalStyles = css({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 'zIndexMax',
  pointerEvents: 'none',
});

export const tooltipContentStyles = cva({
  base: {
    position: 'absolute',
    backgroundColor: 'white',
    color: '#888888',
    fontSize: 'sm',
    lineHeight: 'sm',
    padding: '2x',
    borderRadius: '4px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey400',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    maxWidth: 'none', // Width controlled by size prop
    wordWrap: 'break-word',
    zIndex: 'zIndexMax',

    // Smooth fade transitions
    opacity: 0,
    transform: 'translateY(-4px)',
    transitionProperty: 'opacity, transform',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-in-out',
    pointerEvents: 'none', // Prevent interaction during fade

    // Visible state
    '&[data-visible="true"]': {
      opacity: 1,
      transform: 'translateY(0)',
      pointerEvents: 'auto', // Re-enable interaction when fully visible
    },

    // Respect reduced motion preferences
    '@media (prefers-reduced-motion: reduce)': {
      transitionProperty: 'none',
      transform: 'none',
    },

    // Mobile-specific styling - no maxWidth override, controlled by size prop
    '@media (max-width: 767px)': {
      // Width controlled by size prop and component logic
    },
  },
  variants: {
    position: {
      above: {
        marginBottom: '1x',
      },
      below: {
        marginTop: '1x',
      },
    },
  },
});

export const tooltipArrowStyles = cva({
  base: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderColor: 'transparent',
    zIndex: '9999999', // Higher than border arrow

    // Mobile-specific positioning - remove conflicts, handle via inline styles
    '@media (max-width: 767px)': {
      // Arrow positioning handled by inline styles on mobile
    },
  },
  variants: {
    position: {
      above: {
        top: 'calc(100% - 1px)', // Sit on top of border arrow
        borderTopColor: 'white',
        borderTopWidth: '6px',
        borderLeftWidth: '6px',
        borderRightWidth: '6px',
        borderBottomWidth: 0,
      },
      below: {
        bottom: '100%',
        borderBottomColor: 'white',
        borderBottomWidth: '6px',
        borderLeftWidth: '6px',
        borderRightWidth: '6px',
        borderTopWidth: 0,
      },
    },
  },
});

export const tooltipArrowBorderStyles = cva({
  base: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderColor: 'transparent',
    zIndex: 'zIndexMax',

    // Mobile-specific positioning - remove conflicts, handle via inline styles
    '@media (max-width: 767px)': {
      // Arrow positioning handled by inline styles on mobile
    },
  },
  variants: {
    position: {
      above: {
        top: '100%',
        borderTopColor: 'hpxGrey400',
        borderTopWidth: '7px',
        borderLeftWidth: '7px',
        borderRightWidth: '7px',
        borderBottomWidth: 0,
      },
      below: {
        bottom: 'calc(100% + 1px)', // Account for border
        borderBottomColor: 'hpxGrey400',
        borderBottomWidth: '7px',
        borderLeftWidth: '7px',
        borderRightWidth: '7px',
        borderTopWidth: 0,
      },
    },
  },
});

export const tooltipBackdropStyles = css({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 'zIndexMax',
  pointerEvents: 'auto',
  backgroundColor: 'transparent',
});
